<div class="relative group">
  <!-- Scrollable container -->
  <div
    #scrollContainer
    class="flex gap-5 overflow-x-auto scroll-smooth pr-8 scrollbar-none [&::-webkit-scrollbar]:hidden"
    style="scrollbar-width: none; -ms-overflow-style: none;"
  >
    @for (item of config.items; track item.id) {
      <button
        class="flex-shrink-0 px-3 py-2 font-bold text-sm transition-colors duration-200 whitespace-nowrap"
        [ngClass]="{
          'text-cyan-highlight': item.isSelected,
          'text-white': !item.isSelected && !item.isDisabled,
          'text-white/50 cursor-not-allowed': item.isDisabled,
          'hover:text-cyan-highlight/80': !item.isDisabled && !item.isSelected
        }"
        [disabled]="item.isDisabled"
        (click)="handleItemClick(item)"
        type="button"
        [attr.aria-pressed]="item.isSelected"
        [attr.aria-label]="'Filter by ' + item.label"
      >
        {{ item.label }}
      </button>
    }
  </div>

  <!-- Right scroll arrow with circular backdrop blur (shown only when content overflows) -->
  @if (showRightArrow) {
    <button
      class="absolute right-0 top-1/2 -translate-y-1/2 z-10
             flex items-center justify-center w-8 h-8 rounded-full
             bg-black/30 backdrop-blur-sm
             text-white hover:text-cyan-highlight hover:bg-black/40
             transition-all duration-200"
      (click)="scrollRight()"
      type="button"
      aria-label="Scroll right"
    >
      <nrc-icon name="arrow-back" class="w-4 h-4 rotate-180" />
    </button>
  }
</div>
